var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle5A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hairstyle:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_a_6_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M472.8,191.1c-0.2-4.9-1.1-8.7-4.1-12.7c-0.4,6.6-4.4,13.5-8.1,16.5c2.1-17.3,2.1-51.1-13.9-67.9 c1,3.1,0.2,8.4-2.2,11.1c-0.7-3.3-1.7-6.5-3.1-9.7c-1.8-4-7.4-12-3.3-18.5c-5.7,0.4-8.7,5.3-10.3,11.1c-1.1-3.3-2.6-6.3-4.7-9 c-6-7.7-26-21.9-15.5-32.6c-11.8,4-20,10.8-25.8,19.1c-1.4-17-7.3-32.4-26-37.4c5.3,3.2,3.2,12,2.1,16.2 c-3.8,9.1-9.4,16.8-13.8,25c-0.9-1-1.8-2-2.7-2.9c-4.8-4.3-8-8.5-11.1-13.6c-0.9-1.6-1.5-3.2-2-4.9c-1-3.4-1.1-7.2-0.1-11.5 c-4.6,3.2-8.8,6.5-12.3,10.3c-1.2,1.3-2.3,2.6-3.3,3.9c-2,3-3.5,6.1-4.7,9.3c-1.1,3.2-1.8,6.5-2.2,9.8c-0.2,2.8-0.2,5.7-0.1,8.5 c-5.8-4.3-11.7-7.9-11.5-17.1c-9.4,5.4-19,14.8-22.9,25c-2.3,6.2-2.7,13-1.7,19.7c-3.9-3.3-7.3-6.4-9.3-10.1 c-8.1,6.9-13.8,26.2-6.1,38.1c-3.2-1.5-7.9-6-8.4-9.2c-5.7,13.3-4.3,26.7-3.5,41c0.6,10.4,8.5,25.4,14.1,34.3 c4.2,6.8,7.7,13.4,10.2,20.4c0-0.6,0-1,0-1.3c-0.2-7.4,0.5-14.5,0.7-21.9c0.3-21.4,6.9-41.6,21.7-53.8c1-0.9,2.1-1.7,3.3-2.5 c8-5.6,18.1-9,30.6-9.5c1.9-0.3,3.8-0.6,5.6-0.8c0.2,0,0.4,0,0.6-0.1c9-1.1,18-1.6,27-2.1c0.7,0,1.4-0.1,2.1-0.1 c1.4-0.1,2.8-0.1,4.2-0.2c3.2-0.2,6.4-0.4,9.6-0.5c1.7-0.1,3.5-0.2,5.2-0.3c7.2-0.3,14.4-0.5,21.5,0c7.7,0.5,14.1,2.4,19.7,5.8 c1,0.6,2.1,1.3,3.1,2.1c3.4,2.6,6.6,5.7,9.6,9.7c0.5,0.6,1,1.3,1.4,2c0.5,0.7,1,1.4,1.4,2.1c5.9,9.5,8.2,20.2,10.9,31.2 c2.7,10.7,5.5,24,7.8,37.1C457.9,231.9,473.7,212,472.8,191.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M282.8,102.5c-5.1,4.8-9.3,10.5-11.6,16.5c-4.3,11.3-1.8,24.5,2.6,35.5c2.1,5.2,8.9,17.3,15.1,21.8 c1.4-1.2,3-2.3,4.5-3.3C275.9,154.4,272.1,125.1,282.8,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M315.4,107.9c-0.9-12.9,2.9-25.8,12.1-34c0.1-1.5,0.3-3,0.6-4.6c-4.6,3.2-8.8,6.5-12.3,10.3 c-1.2,1.3-2.3,2.6-3.3,3.9c-2,3-3.5,6.1-4.7,9.3c-1.1,3.2-1.8,6.5-2.2,9.8c-1,16.9,2.2,34,12.6,48.2c2.1,3.1,4.4,6,6.9,8.8 c1.2,1.3,2.4,2.6,3.7,3.8c4.7-0.6,9.5-1,14.2-1.3c-1.2-1.3-2.4-2.7-3.5-4.1C327.1,144,317.5,127,315.4,107.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M350.6,124.7c0-1.9,0.2-3.9,0.4-5.8c0.3-6.6,2.8-12.3,5.6-17.8c0.7-1.4,1.5-2.7,2.2-4.1 c6.4-9.6,8.9-22.3,4.3-33.2c-2.2-1.1-4.6-2.1-7.4-2.8c5.3,3.2,3.2,12,2.1,16.2c-7.4,18.1-22.3,30.6-20.3,52.3 c0.3,3.4,1.1,6.6,2.2,9.7c3,8.2,8.6,15.6,16,22.1c2.1-0.1,4.2-0.2,6.3-0.3c0.5,0,1-0.1,1.4-0.1c-1-1.3-2-2.6-2.9-4 C353.9,147.9,350.4,136.3,350.6,124.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M381,154.3c2-14.2-1-29.3,2.5-43c0.4-1.7,1-3.4,1.7-5.1c4-10.5,11.8-17.5,20-23.1 c0.5-1.3,1.3-2.5,2.5-3.7c-26,8.9-34.8,31.3-38.2,53.9c-0.9,5.9-0.5,10.9,0,16.7c0.2,2.6,1.7,7.1,2.3,10.6 c2.7-0.1,5.3-0.3,8-0.4c0.2-0.7,0.3-1.3,0.5-2C380.5,156.8,380.8,155.6,381,154.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M407.3,125.9c-2.3-7.9-5.2-17.3-2.3-25.4c-3.3,3.7-4,8.3-4.3,12.9c-0.7,9.8,3.1,17.3,4.2,26.4 c0.9,7.5-1.2,14-3.3,20.6c1.8,0.2,3.5,0.5,5.2,0.9c1-2.2,1.6-4.6,2.2-6.4C411.9,144.9,410.1,135.6,407.3,125.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M441.4,128.3c-1.8-4-7.4-12-3.3-18.5c-1.2,0.1-2.3,0.4-3.3,0.9c-1.2,3.6-1.3,7.4-1,11.3 c0.1,1.5,0.3,3.1,0.5,4.6c1.1,8.7,1.4,17.9-0.1,26.6c-0.3,1.7-0.7,3.5-1.2,5.2c-1.4,4.5-3.5,9.9-6.6,14.1 c1.5,1.6,3,3.3,4.5,5.2c1,1.3,2,2.7,2.8,4.1C445.3,166.2,449.3,145.9,441.4,128.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6F110D",
    d: "M259,147.2c-3,16,4.4,33.9,18.7,42c1.2-1.9,2.4-3.7,3.8-5.4C265.3,174.1,260.5,160.2,259,147.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle5A);
export default __webpack_public_path__ + "static/media/man_hairstyle_5a.dd774163e985f9fbfcec2bfe71ad9d57.svg";
export { ForwardRef as ReactComponent };